var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVideoCall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 16,
    viewBox: "0 0 25 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0h9a4 4 0 014 4v7.8a4 4 0 01-4 4H4a4 4 0 01-4-4V4a4 4 0 014-4zm15.452 4.968l3.36-2.198a1 1 0 011.548.836v8.28a1 1 0 01-1.489.873l-3.36-1.88a1 1 0 01-.511-.873V5.805a1 1 0 01.452-.837z",
    fill: "#5096E8",
    fillRule: "evenodd"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCall);
export default __webpack_public_path__ + "static/media/video-call.37487e40320b9a573c135dc2cd22dfbd.svg";
export { ForwardRef as ReactComponent };